// styles/icons.js
// Icon imports - organised alphabetically for sanity
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ArchiveIcon from '@mui/icons-material/Archive';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import BallotIcon from '@mui/icons-material/Ballot';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import BlockIcon from '@mui/icons-material/Block';
import BusinessIcon from '@mui/icons-material/Business';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CampaignIcon from '@mui/icons-material/Campaign';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import CategoryIcon from '@mui/icons-material/Category';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EventIcon from '@mui/icons-material/Event';
import ExtensionIcon from '@mui/icons-material/Extension';
import EventNoteIcon from '@mui/icons-material/EventNote';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FitnessCenter from '@mui/icons-material/FitnessCenter';
import FormatShapesIcon from '@mui/icons-material/FormatShapes';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import HubIcon from '@mui/icons-material/Hub';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import ImageIcon from '@mui/icons-material/Image';
import InfoIcon from '@mui/icons-material/Info';
import InsightsIcon from '@mui/icons-material/Insights';
import LanguageIcon from '@mui/icons-material/Language';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutlined';
import MonitorHeart from '@mui/icons-material/MonitorHeart';
import MovieIcon from '@mui/icons-material/Movie';
import PaymentsIcon from '@mui/icons-material/Payments';
import PeopleIcon from '@mui/icons-material/People';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutlined';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import PsychologyIcon from '@mui/icons-material/Psychology';
import PublicIcon from '@mui/icons-material/Public';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import SettingsInputAntennaOutlinedIcon from '@mui/icons-material/SettingsInputAntennaOutlined';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TimelineIcon from '@mui/icons-material/Timeline';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import TvIcon from '@mui/icons-material/Tv';
import TvOutlinedIcon from '@mui/icons-material/TvOutlined';
import UpdateIcon from '@mui/icons-material/Update';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * Entity Icons Mapping
 * Maps semantic entity names to Material-UI icons
 * Provides consistent iconography across the application
 */
export const entityIcons = {
    // Actions
    add: AddCircleIcon,
    archive: ArchiveIcon,
    check: CheckIcon,
    close: CloseIcon,
    copy: ContentCopyIcon,
    copyBooking: LibraryAddIcon,
    delete: DeleteIcon,
    download: FileDownloadIcon,
    edit: EditIcon,
    info: InfoIcon,

    // Business Entities
    activity: TimelineIcon,
    activity_ol: TimelineOutlinedIcon,
    admin: AdminPanelSettingsIcon,
    adtech: HubIcon,
    adtech_ol: HubOutlinedIcon,
    adtechgroup: AccountTreeIcon,
    adtechgroup_ol: AccountTreeOutlinedIcon,
    agency: HandshakeIcon,
    agency_ol: HandshakeOutlinedIcon,
    booking: EventNoteIcon,
    booking_ol: EventNoteOutlinedIcon,
    broadcaster: TvIcon,
    broadcaster_ol: TvOutlinedIcon,
    client: BusinessIcon,
    customer: BusinessIcon,
    client_ol: BusinessOutlinedIcon,
    partition: CallSplitIcon,
    distributor: LocalShippingIcon,
    distributor_ol: LocalShippingOutlinedIcon,
    user: PeopleIcon,
    user_ol: PeopleOutlineIcon,

    // Campaign & Media
    campaign: CampaignIcon,
    campaign_ol: CampaignOutlinedIcon,
    channel: SettingsInputAntennaIcon,
    channel_ol: SettingsInputAntennaOutlinedIcon,
    creative: AutoFixHighIcon,
    creative_ol: AutoFixHighOutlinedIcon,
    video: MovieIcon,
    image: ImageIcon,
    audio: AudiotrackIcon,

    // Tags & Tracking
    impressionTag: BallotIcon,
    impressionTag_ol: BallotOutlinedIcon,
    siteTag: LocalOfferIcon,
    siteTag_ol: LocalOfferOutlinedIcon,

    // Site Detection
    tagManager: ExtensionIcon,
    csp: SecurityIcon,
    consent: PrivacyTipIcon,
    lastChecked: UpdateIcon,

    // System & Technical
    calendar: CalendarTodayIcon,
    country: PublicIcon,
    creativeFormat: AspectRatioIcon,
    creativeType: FormatShapesIcon,
    database: DatasetLinkedIcon,
    date: EventIcon,
    domain: LanguageIcon,
    email: MailOutlineIcon,
    settings: SettingsSuggestIcon,
    taxonomy: CategoryIcon,

    // Financial
    money: AttachMoneyIcon,
    payment: PaymentsIcon,

    // Status Indicators
    pingcheck: CheckCircleIcon,
    pingwarning: WarningAmberIcon,
    pingdead: BlockIcon,

    // Analytics
    barchart: BarChartIcon,
    insight: InsightsIcon,
    analyse: PsychologyIcon,
    reach: PeopleAltIcon,

    // Miscellaneous
    fitness: FitnessCenter,
    health: MonitorHeart,
};
